"use strict";

exports.__esModule = true;
exports.getWixP = void 0;

var _wixParamsUtils = require("../services/wix-params-utils");

// takes wix param or wix param path and state (determines is mobile from state) or boolean
var getWixP = function getWixP(wixParam, isMobile) {
  return (0, _wixParamsUtils.wixP)(wixParam, isMobile);
};

exports.getWixP = getWixP;